import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { PlusOutlined } from '@ant-design/icons';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';


export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?:any;
};

const SaveButton = ({ comcode,custom, ...otherProps }: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    children: label,
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        {...props}
        icon={<PlusOutlined color="white"/>}
        type="primary"
        style={{ width: 100, height: 40, margin: 5 }}
      />
    );
  }
};

export default SaveButton;
